import React from 'react';
import './LoadingCard.scss';

const LoadingCard = (styles) => {
  return (
    <div
      style={{...styles}}
      className={`loading-card`}
    />
  )
}

export default LoadingCard;
